import { useCallback, useEffect, useRef, useState } from 'react';
import { fetchSection, Section, Sections, sectionLabels } from './model';
const keys = Object.keys(sectionLabels) as Section[];
type Snapshot = Partial<{ [K in Section]: Sections[K] }>;
export default function useDashboardData() {
  const [data, setData] = useState<Snapshot>({}), [times, setTimes] = useState<Partial<Record<Section, string>>>({});
  const [errors, setErrors] = useState<Section[]>([]), [loading, setLoading] = useState(true);
  const alive = useRef(true), generation = useRef(0);
  const reload = useCallback(async () => {
    const id = ++generation.current; setLoading(true);
    const results = await Promise.allSettled(keys.map(key => fetchSection(key)));
    if (!alive.current || id !== generation.current) return;
    const updates: Snapshot = {}, timestamps: Partial<Record<Section, string>> = {}, failures: Section[] = [];
    results.forEach((result, i) => {
      const key = keys[i];
      if (result.status === 'fulfilled') { Object.assign(updates, { [key]: result.value }); timestamps[key] = new Date().toISOString(); }
      else failures.push(key);
    });
    setData(previous => ({ ...previous, ...updates })); setTimes(previous => ({ ...previous, ...timestamps }));
    setErrors(failures); setLoading(false);
  }, []);
  useEffect(() => { alive.current = true; reload(); return () => { alive.current = false; generation.current += 1; }; }, [reload]);
  return { data, times, errors, loading, reload };
}
